import React from 'react';

import Concept from 'Scenarios/Concept';
import CommuteTimes from 'CommuteTimes';
import { Translation } from 'giro-react-toolkit/source/Translation';
import PropTypes from 'prop-types';

import "./Footer.scss";

const Comment = () => {
   if (!reachMap.commentLink)
      return (null);

   return (
      <div className="comment">
         <a className="comment__link" href={reachMap.commentLink} target="_blank">
            <Translation resourceKey={ 'ReachMapRes.CommentLinkText' }/>
         </a>
      </div>);
};

const Footer = (props) => {
   return (
      <div className={props.className}>
         <CommuteTimes isochroneParam={props.isochroneParam} />
         <Concept
            selectedConcept={props.selectedConcept}
            onSelectedConcept={props.onSelectedConcept} />
         <div className="concept-note">
            {reachMap.concept.ConceptNote}
         </div>
         <Comment />
      </div>
   );
};

Footer.propTypes = {
   /**
    * The footer classnames
    */
   className: PropTypes.string,
   /**
    * The selected concept value
    */
   selectedConcept: PropTypes.string,
   /**
    * A callback called when a concept is selected
    */
   onSelectedConcept: PropTypes.func,
}
export default Footer;
